import React, { Component } from 'react';
import { connect } from 'react-redux';
import IgniteDataTable from '../../../common/datatable';
import { history } from '../../../../store';
import {downloadPriceIt} from '../../../../actions/price-it';

class PriceItList extends Component {
  download(id) {
    this.props.dispatch(downloadPriceIt(id));
  }

  render() {
    const columns = [
      {
        prop: 'name',
        title: 'Name'
      },
      {
        prop: 'groups-linked',
        title: 'Groups Linked',
        width: '200'
      },
      {
        prop: 'active',
        title: 'Active',
        width: '100'
      }
    ];

    const actions = [
      {
        label: 'Details',
        callback: (row) => {
          history.push(`/admin/objectives/price-it/${row.id}`);
        }
      },
      {
        label: 'Download',
        color: 'grey',
        callback: (row) => {
          this.download(row.id);
        }
      }
    ];
    return (
      <IgniteDataTable
        data={this.props.priceIts}
        hasAttributes
        columns={columns}
        actions={actions}
        hideId={false}
        remote
      />
    );
  }
}

export default connect()(PriceItList);



// WEBPACK FOOTER //
// ./src/components/admin/objectives/price_it/price-it-list.jsx